import React from 'react';
export function Draw() {
  return <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.952381" y="0.952381" width="20.0952" height="20.0952" fill="transparent" stroke="currentColor" strokeWidth="1.90476" />
    </svg>;
}